import { createSlice } from '@reduxjs/toolkit'
import { setItem } from '../utils/localStorage'

export const authSlice = createSlice({
    name: 'authen',
    initialState: {
        isLogin: false,
        data: {
            access_token: '',
            userData: {}
        }
    },
    reducers: {
        loginAction: (state, action) => {
            const { token, user } = action.payload
            setItem('isLogin', true)
            setItem('access_token', JSON.stringify(token))
            setItem('userData', JSON.stringify(user))
            return {
                ...state,
                isLogin: true,
                data: {
                    access_token: token,
                    userData: user
                }
            }
        },
        logoutAction: (state) => {
            localStorage.clear()
            return {
                ...state,
                isLogin: false,
                data: {
                    access_token: '',
                    userData: {}
                }
            }
        },
        userLoaderAction: (state, action) => {
            return {
                ...state,
                isLogin: true,
                data: {
                    access_token: action.payload.access_token || state.data.access_token,
                    userData: action.payload.user || state.data.userData,
                }
            };
        }
    },
})
export const { loginAction, logoutAction, userLoaderAction } = authSlice.actions
export default authSlice.reducer